import type {
  FlightClass,
  FlightType,
} from '@lt/api/dist/methods/packages/types';

import { useTranslation } from '@lt/localization';
import React from 'react';
import { noConcretizationFlightType } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Flights/constants';
import { getFlightTypeData } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/utils/flightUtils';
import { FLIGHTS_DIRECTIONS } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import styled from 'styled-components';
import FlightTypeComponent from './components/FlightType';

type Props = {
  toType: FlightType;
  toClass: FlightClass;
  toWarning?: boolean;

  backType: FlightType;
  backClass: FlightClass;
  backWarning?: boolean;
  isFlightChangable: boolean;
};

const FlightTypes = (props: Props) => {
  const {
    toType,
    toClass,
    toWarning,
    backType,
    backClass,
    backWarning,
    isFlightChangable,
  } = props;
  /*
    Если рейс без конкретизации, то туда и обратно - чартерные рейсы
  */
  const isFlightsTypeEqual = isFlightChangable
    ? true
    : toType === backType && toClass === backClass;

  const getFlightDataParams = isFlightChangable
    ? noConcretizationFlightType
    : {
        type: toType,
        warning: toWarning,
        business: toClass === 'business',
      };

  const { t } = useTranslation();

  return (
    <Wrapper>
      {isFlightsTypeEqual && (
        <>
          {t('checkout.flight.sidebar')} –{' '}
          <FlightTypeComponent
            showFlightClass={!isFlightChangable}
            data={getFlightTypeData(getFlightDataParams)}
            showPluralTitle
          />
        </>
      )}
      {!isFlightsTypeEqual && (
        <>
          <div>
            {`${FLIGHTS_DIRECTIONS[0]} – `}
            <FlightTypeComponent
              showFlightClass
              showPluralTitle={false}
              data={getFlightTypeData(getFlightDataParams)}
            />
          </div>
          <div>
            {`${FLIGHTS_DIRECTIONS[1]} – `}
            <FlightTypeComponent
              showFlightClass
              showPluralTitle={false}
              data={getFlightTypeData({
                type: backType,
                warning: backWarning,
                business: backClass === 'business',
              })}
            />
          </div>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  color: #919499;
`;

export default FlightTypes;
